export default __webpack_public_path__ + "static/media/logo.c97ba5bd.png";